export default __webpack_public_path__ + "static/media/pa.4dd0dc1a.svg";